<div class="wrapper">
  <section class="header-section justify-between flex flex-row">
    <div class="heading-section mb-[40px]">
      <div class="heading text-type-1">
        Search Results
      </div>
      @if (searchText) {
        <div class="sub-heading text-type-11">
          {{ totalSearchCount || 0 }} results found for "{{ searchText }}"
          @if (isTruncated) {
            <span class="truncation-note"> — showing the top {{ shownSearchCount }}</span>
          }
        </div>
      }
    </div>
    <div
      class="filters-section flex flex-row gap-[20px]"
      >
      <app-date-range-filter
        [defaultDateValue]="defaultDateValue"
        />
    </div>
  </section>
  <div class="tab-group">
    <!-- Content-width tabs (not stretched): the category strip scrolls
         horizontally via the header's paginator once it overflows, matching
         the mobile tab strip. -->
    <mat-tab-group
      #tabGroup
      [mat-stretch-tabs]="false"
      [selectedIndex]="selectedTabIndex"
      class="contents-tab-group"
      >
      @for (tab of tabsList; track tab.searchType) {
        <mat-tab [label]="tab.label">
          <app-search-results-list
            [entityType]="tab.searchType"
            class="tab-content"
            />
        </mat-tab>
      }
    </mat-tab-group>
  </div>
</div>
